var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-item"},[_c('p',{staticClass:"show-item--label"},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.help)?_c('info-tooltip',{attrs:{"tooltip-content":_vm.help}}):_vm._e()],1),_c('div',{staticClass:"show-item--value"},[_vm._t("value",function(){return [_c('p',[_vm._v(" "+_vm._s(_vm.value)+" ")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }